import React from "react";
import Chats from "./components/DoubleChatView";
import Login from "./screens/RegisterScreen"; 
import SingleChatView from "./components/SingleChatView";

const rootPath = 'auth'

export const authRoutes = [
  {
    path: `${rootPath}/login`,
    element: <Login />,
    isProtected: false
  },
  {
    path: `${rootPath}/chatlist`,
    element: <Chats />,
    isProtected: true
  },
  {
    path: `${rootPath}/chats`,
    element: <SingleChatView />,
    isProtected: true
  }
];
